import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const Manuscript = () => {
  return (
    <Container>
    <h2 className="display-6 fw-bold my-4">Manuscript Submission & Instructions for Authors
    </h2>
    <hr />

    <h4 className="fw-bold">Authors Benefits</h4>
  
    <ul className="joab-common-para my-4">
        <li>maintain a quick publication procedure — manuscripts are published within 5-9 weeks of submission, provided that no major revisions are required</li>

        <li>publish full open access journals — readers can access all articles published on this platform for free, including state-of-the-art review articles</li>

        <li>publish citation-tracked journals — Green Publication is working towards quick coverage and citation-tracking of all journals in Scopus.</li>
       
    </ul>

    <h4 className="fw-bold">English Editing</h4>
    <p className="joab-common-para my-4">Submitted papers should be well formatted and use good English and should be according the manuscript layout described in the author guidelines. Authors are advised to use the Green Publication Author Services prior to submission, publication or manuscript revision. A reduction of the Author Services fees is possible in combination with the submission of a manuscript to one of the journals published by Green Publication.</p>


  </Container>
  );
};

export default Manuscript;
